import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaLinkedin,
  FaArrowRight
} from "react-icons/fa";

const quickLinks = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "Contact", to: "/contact" }
];

function Footer() {
  const currentYear = new Date().getFullYear();

  // Force page scroll to top when navigating via footer links
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-slate-950 text-slate-400 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 py-16">

        {/* Main Footer */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">

          {/* Company Info */}
          <div className="lg:col-span-5">
            <h3 className="text-3xl font-bold text-white mb-4 tracking-tight">
              VAMCO <span className="text-[#C8A96B]">&amp;</span> ASSOCIATES
            </h3>

            <p className="font-serif text-slate-300 leading-relaxed max-w-md mb-4 font-semibold text-sm text-justify">
              Vamco Architectural Prospective Drawings Services LLC, alongside
              our trusted associates Falcosys Infotech Ltd and Astra
              Engineering Consultants, operates as a premier
              multi-disciplinary engineering .
            </p>

            <p className="font-serif text-slate-400 leading-relaxed max-w-md font-semibold text-xs text-justify">
              Specializing in high-precision structural rebar detailing,
              accurate Bar Bending Schedules (BBS) optimized to minimize steel
              scrap, and fully integrated MEP BIM coordination services.
            </p>

            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.linkedin.com/in/varun-%D9%81%D8%B1%D9%86-pillai-%D8%A8%D9%8A%D9%84%D9%8A-varun/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our LinkedIn profile"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-slate-800 text-slate-400 hover:text-white hover:border-[#C8A96B] hover:bg-[#C8A96B]/10 transition-colors duration-300"
              >
                <FaLinkedin />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-3">
            <h4 className="text-white font-semibold text-lg mb-5 relative inline-block">
              Quick Links
              <span className="absolute -bottom-2 left-0 w-8 h-0.5 bg-[#C8A96B]" />
            </h4>

            <ul className="space-y-3 text-sm mt-6">
              {quickLinks.map(({ label, to }) => (
                <li key={to}>
                  <Link
                    to={to}
                    onClick={handleScrollToTop}
                    className="group flex items-center gap-2 hover:text-white transition-colors duration-300"
                  >
                    <FaArrowRight className="text-xs text-[#C8A96B] transition-transform duration-300 group-hover:translate-x-1" />
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-4">
            <h4 className="text-white font-semibold text-lg mb-5 relative inline-block">
              Contact Us
              <span className="absolute -bottom-2 left-0 w-8 h-0.5 bg-[#C8A96B]" />
            </h4>

            <div className="space-y-4 text-sm mt-6">

              <div className="flex items-start gap-3">
                <FaMapMarkerAlt className="mt-1 text-[#C8A96B] shrink-0" />
                <p className="text-slate-400">
                  Deira Clock Tower,
                  <br />
                  Dubai, UAE
                </p>
              </div>

              <div className="flex items-start gap-3">
                <FaPhoneAlt className="text-[#C8A96B] mt-1 shrink-0" />
                <div className="flex flex-col gap-0.5">
                  <a
                    href="tel:+971569140526"
                    className="hover:text-white transition-colors duration-300"
                  >
                    +971 56 914 0526
                    <span className="text-slate-600"> (Mobile)</span>
                  </a>
                  <a
                    href="tel:+97145479597"
                    className="hover:text-white transition-colors duration-300 text-xs text-slate-500"
                  >
                    +971 4 547 9597
                    <span className="text-slate-600"> (Landline)</span>
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <FaEnvelope className="text-[#C8A96B] mt-1 shrink-0" />
                <div className="flex flex-col gap-1 text-xs break-all">
                  <a
                    href="mailto:info@vamcouae.com"
                    className="hover:text-white transition-colors duration-300 text-sm text-slate-400"
                  >
                    info@vamcouae.com
                  </a>
                  <a
                    href="mailto:ayyadurai.r@falcosys.in"
                    className="hover:text-white transition-colors duration-300 text-slate-500"
                  >
                    ayyadurai.r@falcosys.in
                  </a>
                </div>
              </div>

            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">

          <p className="text-sm text-slate-500 text-center md:text-left">
            © {currentYear} Vamco Architectural Prospective Drawings Services LLC.
            All Rights Reserved.
          </p>

          <p className="text-xs text-slate-600 font-mono tracking-wider">
            VAMCO • FALCOSYS • ASTRA ENGINEERING
          </p>

        </div>

      </div>
    </footer>
  );
}

export default Footer;
